import { Steart } from 'app/models/core/steart.model';
import { ZeWidgetDef, ZeWidgetItem } from './vbl.ze.widgets';

export const LbsgZeWidgets: ZeWidgetDef[] = [
	new ZeWidgetDef({
		title: 'Sach Firmen',
		subTitle: '(Bewertung)',
		key: 'firmen_sach_gesamt_lbsg',
		stearts: [Steart.LBSG],
		items: [
			new ZeWidgetItem({
				text: <strong>Individuelles Arbeitsgebietsziel 100%</strong>,
				posId: 2217041,
			}),
		],
	}),
	new ZeWidgetDef({
		title: 'oder Unfall und Sach Firmen Gesamt',
		subTitle: '(Bewertung ohne Anpassung)',
		key: 'firmen_sach_gesamt_und_unfall_lbsg',
		stearts: [Steart.LBSG],
		items: [
			new ZeWidgetItem({
				text: <strong>Individuelles Arbeitsgebietsziel 200%</strong>,
				posId: 2217042,
			}),
		],
	}),
];
